import Vue from 'vue'

import 'vue-css-donut-chart/dist/vcdonut.css';
import Donut from "vue-css-donut-chart/src/components/Donut.vue";

Vue.component('vc-donut', Donut)
